export default __webpack_public_path__ + "static/ainc_podcast_logo@2x-1a43b3fffabffd179357997dfcdf8a7b.png";